import companyLogo from '../../assets/images/logo.png';
import companySmallLogo from '../../assets/images/logo_small.png';
import outil_1 from '../../assets/images/outil (1).png';
import outil_2 from '../../assets/images/outil (2).png';
import outil_3 from '../../assets/images/outil (3).png';
import outil_4 from '../../assets/images/outil (4).png';
import outil_5 from '../../assets/images/outil (5).png';
import outil_6 from '../../assets/images/outil (6).png';
import outil_7 from '../../assets/images/outil (7).png';
import outil_8 from '../../assets/images/outil (8).png';
import outil_9 from '../../assets/images/outil (9).png';
import outil_10 from '../../assets/images/outil (10).png';
import outil_11 from '../../assets/images/outil (11).png';
import outil_12 from '../../assets/images/outil (12).png';
import outil_13 from '../../assets/images/outil (13).png';
import avatar from '../../assets/images/user_profile_image.png';
import comImg from './../../assets/images/passer-la-commande.png';
import rechargeImg from './../../assets/images/recharge.png';
import carImg from './../../assets/images/car.png';

const companyName = 'Quincaillerie Générale Yeli Kamissoko';

const companyLittleName = 'Yeli Kamissoko';
const companyServices1 =
  'Vente des Matériaux de Construction & Accessoires';
const companyServices2 = 'Ciment - Fer - Tôles - Divers';

const companyOwnerservices = 'Commerce Général';

const companyAdresse = "Diongaga village cercle Yelimane - Kayes , Rép Mali";

const companyTel = '+223 76-07-08-14 / 65-86-36-01';

export {
  companyLogo,
  companySmallLogo,
  companyName,
  companyLittleName,
  companyServices1,
  companyServices2,
  companyOwnerservices,
  companyAdresse,
  companyTel,
  outil_1,
  outil_2,
  outil_3,
  outil_4,
  outil_5,
  outil_6,
  outil_7,
  outil_8,
  outil_9,
  outil_10,
  outil_11,
  outil_12,
  outil_13,
  avatar,
  comImg,
  rechargeImg,
  carImg,
};
